<script setup lang="ts">
import Button from '@/components/ui/button/Button.vue';
import OfferTimer from './OfferTimer.vue';
import { Offer } from '@/types/offer';
import GetAnOffer from '@/components/forms/GetAnOffer.vue';
import { ref } from 'vue';

defineProps<{ offer: Offer }>();
const getAnOffer = ref(false);
</script>

<template>
  <div class="group grid h-max overflow-hidden rounded-2xl bg-[#333333] text-white lg:aspect-video lg:grid-cols-2">
    <div class="flex h-full flex-col justify-between p-8 lg:p-12 xl:p-20">
      <p v-show="offer.badge" class="mb-4 text-sm tracking-wide text-green-400">
        {{ offer.badge }}
      </p>

      <h2 class="line-clamp-3 text-2xl leading-tight font-bold xl:text-5xl" v-html="offer.name"></h2>

      <p v-show="offer.description" class="mt-4 line-clamp-3 max-w-md text-zinc-400">
        {{ offer.description }}
      </p>

      <OfferTimer v-if="offer.end_at" :expires-at="offer.end_at" />

      <div class="flex-1"></div>

      <Button @click.prevent="getAnOffer = true" size="lg" class="mt-8 cursor-pointer"> Получить предложение </Button>
    </div>

    <div class="relative overflow-hidden">
      <img
        v-if="offer.image"
        :src="offer.image"
        loading="lazy"
        class="absolute inset-0 h-full w-full object-cover transition-transform duration-1200 group-hover:scale-105"
      />

      <div class="absolute inset-0 bg-linear-to-r from-black/30 to-transparent" />
    </div>
  </div>
  <GetAnOffer v-model="getAnOffer" :offer-id="offer.id" />
</template>
